export default class UserNameExistsError extends Error {}
